import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadEcta: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"ECTA"} title={"Importar catálogo ECTA"}
  instructions={"Informe a URL do cardápio da ECTA ou o código do estabelecimento."}
  placeholder={"URL da loja ou código do estabelecimento"}
  loadingMessage="Buscando o catálogo da ECTA... Isso pode levar alguns minutos." />;

export default UploadEcta;
